import React from 'react';
import { SHAPES, type KindDetail, type KindSpec, type Shape } from '../../utils/clientSetup';
import { SetupCount, SetupSwitch } from './SetupChoice';
import { SetupDate } from './SetupDays';

/**
 * The questions one of the five main kinds asks — films, podcast, event
 * coverage, photography.
 *
 * Lifted out of NewProjectForm.tsx on 16 Oct 2026 when Something else
 * became its own pick-list: that file had to grow a second kind of detail
 * screen and was already at the size a single safe overwrite can carry.
 * Its sibling is SetupExtraFields.tsx, which does the same job for the
 * extras and asks a different set of questions.
 *
 * **There is no name field here any more.** It belonged to Something
 * else, which no longer has a detail screen of its own — it has a list.
 */
export function SetupKindFields({
  spec,
  detail,
  onChange
}: {
  spec: KindSpec;
  detail: KindDetail;
  onChange: (patch: Partial<KindDetail>) => void;
}) {
  /* Shape means nothing for a set of photographs, or for audio. */
  const shaped = spec.shaped && !(spec.key === 'podcast' && detail.audioOnly);
  return <>
      <SetupCount value={detail.count} ongoing={detail.ongoing} pieces={spec.pieces} onCount={count => onChange({
      count
    })} onOngoing={ongoing => onChange({
      ongoing
    })} data-id="element-1332" data-mp="3pisxf97yu85k" />

      {spec.key === 'podcast' && <SetupSwitch question="Filmed?" options={[{
      key: 'filmed',
      label: 'Filmed'
    }, {
      key: 'audio',
      label: 'Audio only'
    }]} value={detail.audioOnly ? 'audio' : 'filmed'} onPick={key => onChange({
      audioOnly: key === 'audio'
    })} data-id="element-1333" data-mp="hac83yvgxx0b" />}

      {shaped && <SetupSwitch question="What shape" options={SHAPES} value={detail.shape} onPick={key => onChange({
      shape: key as Shape
    })} data-id="element-1334" data-mp="m2c4jhcby7s5" />}

      <SetupDate label="When do they need it" value={detail.due} onChange={due => onChange({
      due
    })} data-id="element-1335" data-mp="v2s3cdi4oqqo" />
    </>;
}